var app = angular.module("leonardo");

var ContactEditDialog = function($scope, $q, $filter, $rootScope, ContactTypeRestService, ContactRestService,
                                 NotificationService, AccountUserService, FormErrorsService, PermissionService) {

  $scope.isEdit = $scope.ngDialogData.contact ? true : false;
  $scope.contact = angular.copy($scope.ngDialogData.contact);
  $scope.accountUserService = AccountUserService;
  $scope.permissionService = PermissionService;
  $scope.contactTypeRestService = ContactTypeRestService;

  $scope.isNull = isNull;

  $scope.emailOptios = [
    {id: 0, name: 'NO'},
    {id: 1, name: 'YES'}
  ];

  if (!$scope.isEdit) {
    $scope.contact = {
      account: $scope.ngDialogData.account
    };
  }
  else {
    $scope.emailType = !isNull($scope.contact.account_user) ? 1 : 0;
    $scope.contact.contact_type = !isNull($scope.contact.contact_type) && !isNull($scope.contact.contact_type.id) ?
      $scope.contact.contact_type.id : $scope.contact.contact_type;
    $scope.contact.account_user = !isNull($scope.contact.account_user) && !isNull($scope.contact.account_user.id) ?
      $scope.contact.account_user.id : $scope.contact.account_user;
    $scope.contact.properties_data = { portfolios: [], properties: [] };
    $scope.contact.properties_data.properties = [];
    if (!isNull($scope.contact.properties)) {
      $scope.contact.properties_data.properties = (angular.isArray($scope.contact.properties) ?
        $scope.contact.properties.map(function (p) { return p && p.id || p; }) : $scope.contact.properties.toString().split(','));
    }
  }

  $scope.accountUser = AccountUserService.getAccountUser($scope.contact.account);

  $scope.getData = function() {
    var defer = $q.defer();
    var account_user = !isNull($scope.contact.account_user) ? AccountUserService.get($scope.contact.account_user) : null;

    $q.when(account_user).then(function (result) {
      var data = {
        name: result ? $filter('username')(result.user) : $scope.contact.name,
        email: result ? '' : $scope.contact.email,
        title: result ? result.user.title : $scope.contact.title,
        account_user: result ? result.id : undefined,
        account: $scope.contact.account,
        client_instance: $scope.contact.client_instance,
        contact_type: $scope.contact.contact_type,
        properties: $scope.contact.properties_data ? $scope.contact.properties_data.properties : [],
      };

      defer.resolve(data);
    });

    return defer.promise;
  };

  $scope.submit = function() {
    $scope.Form.$setSubmitted();

    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    $scope.getData().then(function (data) {
      if ($scope.isEdit) {
        $scope.contact.patch(data).then(function () {
          $rootScope.$broadcast('contact:changed');
          $scope.closeThisDialog();
        });
      }
      else {
        data.key = data.name.toLowerCase().replace(/[^a-zA-Z0-9]+/g, "-");

        ContactRestService.post(data).then(function (result) {
          ContactRestService.updateCollection(result);
          $rootScope.$broadcast('contact:changed');
          $scope.closeThisDialog();
        });
      }
    });
  };

  $scope.resetProperties = function() {
    ContactRestService.resetProperties($scope.contact.id).then(function(result) {
      $scope.contact.contact_properties_manually_modified = false;
      $scope.contact.properties_data = { portfolios: [], properties: [] };
      if (result.properties) {
        $scope.contact.properties_data.properties = result.properties.map(function(p) {
          return p && p.id || p;
        });
      }
      $scope.propertiesJustReset = true;
      NotificationService.success('Contact properties reset to role default');
      $rootScope.$broadcast('contact:changed');
    });
  };

  $scope.$watch('emailType', function (newValue, oldValue) {
    if (newValue !== oldValue){
      if (newValue) {
        $scope.contact.email = '';
      }
      else {
        $scope.contact.account_user = undefined;
      }
    }
  });

};

app.controller('ContactEditDialog', ['$scope', '$q', '$filter', '$rootScope', 'ContactTypeRestService', 'ContactRestService',
  'NotificationService', 'AccountUserService', 'FormErrorsService', 'PermissionService', ContactEditDialog]);
